module.exports = __webpack_public_path__ + "static/avatar-f77324c159d1b8cb9f5725066f3bb6fe.jpg";